var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sign-form',{attrs:{"isEdit":true,"data":_vm.userInfo},on:{"registerChange":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }